import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { Box, Button, IconButton, Tooltip } from "@mui/material";
import { MaterialReactTable, useMaterialReactTable } from "material-react-table";
import { useMemo } from "react";
import { tableConfig, tableStyles } from "../../../commons/table/tableConfig";
import { StyledResolucion } from "../../../styled/Prevencion";

const SustanciasTable = ({ handleCancelResolucion, handleNextForm, data, handleOpenFormularioSustancia, handleDeleteSustancias }) => {

    const handleSubmit = () => {
        handleNextForm('Trabajadores-Sector');
    }

    const columns = useMemo(() => [
        {
            accessorFn: (row) => row.sustancia?.nombreAgente ?? "",
            header: "Código Agente",
            id: "codigoAgente",
            size: 150,
            filterFn: 'includesString',
        },
        {
            accessorFn: (row) => row.sustancia?.descripcionAgente ?? "",
            header: "Descripción",
            id: "descripcion",
            size: 250,
            filterFn: 'includesString',
        },
        {
            accessorFn: (row) => row.sustancia?.nombre ?? "",
            header: "Nombre Comercial",
            id: "nombreComercial",
            size: 200,
            filterFn: 'includesString',
        },
    ], []);

    const table = useMaterialReactTable({
        ...tableConfig,
        columns,
        data,
        enableRowSelection: true,
        positionActionsColumn: 'last',
        displayColumnDefOptions: {
            'mrt-row-actions': {
                header: 'Operaciones',
                size: 200,
                muiTableHeadCellProps: {
                    align: 'left',
                    sx: {
                        ...tableStyles.headerStyle,
                        verticalAlign: 'top'
                    }
                },
            },
        },
        enableRowActions: true,
        initialState: {
            ...tableConfig.initialState,
            density: 'compact',
            pagination: {
                pageSize: 5,
                pageIndex: 0
            }
        },
        renderTopToolbarCustomActions: () => (
            <StyledResolucion.HeaderContainer>
                <StyledResolucion.TableTitle>
                    Sustancias
                </StyledResolucion.TableTitle>
            </StyledResolucion.HeaderContainer>
        ),
        renderRowActions: ({ row }) => (
            <div style={{ display: 'flex', gap: '8px' }}>
                <IconButton
                    variant="text"
                    onClick={() => handleOpenFormularioSustancia({ ...row.original, index: row.index })}
                    size="small"
                >
                    <EditIcon />
                </IconButton>
            </div>
        ),
        renderToolbarAlertBannerContent: ({ selectedAlert, table }) => (
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginLeft: 1,
                }}>
                {selectedAlert}
                <Tooltip title="Eliminar seleccionados">
                    <IconButton
                        onClick={() => {
                            const selectedRows = table.getSelectedRowModel().rows;
                            handleDeleteSustancias(selectedRows, table);
                            table.resetRowSelection();
                        }}
                    >
                        <DeleteIcon />
                    </IconButton>
                </Tooltip>
            </Box>
        ),
        renderBottomToolbarCustomActions: () => (
            <StyledResolucion.TableFooterButtonContainer>
                <Button
                    color="primary"
                    onClick={() => handleOpenFormularioSustancia()}
                >
                    Agregar
                </Button>
            </StyledResolucion.TableFooterButtonContainer>
        ),
    });

    return (
        <>
            <StyledResolucion.TableContainer>
                <MaterialReactTable table={table} />
            </StyledResolucion.TableContainer>

            <StyledResolucion.ButtonContainer>
                <StyledResolucion.CancelButton
                    variant="contained"
                    onClick={handleCancelResolucion}
                >
                    CANCELAR FORMULARIO
                </StyledResolucion.CancelButton>
                <Button
                    disabled={data.length === 0}
                    color="primary"
                    variant="contained"
                    onClick={handleSubmit}
                >
                    SIGUIENTE
                </Button>
            </StyledResolucion.ButtonContainer>
        </>
    );
};

export default SustanciasTable;